/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * In the classic UI the window scrolls. In the v2 frame only <main> scrolls
 * (the header and softphone bar stay put), so code that calls
 * window.scrollTo() would do nothing there. useScrollContainer() hands back
 * whichever element actually scrolls; without a provider it is the window,
 * so classic behaviour is unchanged.
 */

import { createContext, useContext } from "react";

const ScrollContainerContext = createContext(null);

export const ScrollContainerProvider = ScrollContainerContext.Provider;

const windowScroller = {
  scrollTo: (...args) => window.scrollTo(...args),
  get scrollTop() {
    return window.scrollY;
  },
  element: null,
};

export function useScrollContainer() {
  const ref = useContext(ScrollContainerContext);
  if (!ref) return windowScroller;
  // Read the element at call time: on the first render the ref is still empty.
  return {
    scrollTo: (...args) => (ref.current ? ref.current.scrollTo(...args) : window.scrollTo(...args)),
    get scrollTop() {
      return ref.current ? ref.current.scrollTop : window.scrollY;
    },
    get element() {
      return ref.current || null;
    },
  };
}

export default useScrollContainer;
